var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInboxPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10V7L18 10H17ZM17 18H3C2.448 18 2 17.552 2 17V12H5C5.552 12 6 12.448 6 13V14C6 15.105 6.895 16 8 16H12C13.105 16 14 15.105 14 14V13C14 12.448 14.448 12 15 12H18V17C18 17.552 17.552 18 17 18ZM3 7V10H2L3 7ZM6 2H14C14.552 2 15 2.448 15 3V10H14C12.895 10 12 10.895 12 12V13C12 13.552 11.552 14 11 14H9C8.448 14 8 13.552 8 13V12C8 10.895 7.105 10 6 10H5V3C5 2.448 5.448 2 6 2ZM18 4H17V2C17 0.895 16.105 0 15 0H5C3.895 0 3 0.895 3 2V4H2L0 10V18C0 19.105 0.895 20 2 20H18C19.105 20 20 19.105 20 18V10L18 4Z",
    fill: "#FF4040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxPaper);
export default __webpack_public_path__ + "static/media/inboxPaper.17b22ef58bc3bbd6012e262dca4657f0.svg";
export { ForwardRef as ReactComponent };